<template>
    <div class="container">
    <div style="background-color: white; padding: 20px;">
      <h2 style="color: black;">🐾 The Purr-spective on Pet Insurance in Canada 💕  </h2>
      <div style="background-color: white; padding: 20px; border-radius: 10px;">
        <img :src="require('@/assets/cat-sad.gif')" alt="Cat is sad about Canadians not having pet insurance" width="250" height="250" />
        <p style="color: black;">Hey fur-iends, let's talk about something as crucial as the right scratching post—Pet Insurance! 🐱‍👤💰<br>
          
<br>A Bit of Meow-story 📜<br><br>
Did you know the first pet insurance paw-licy was written in 1890? Yup, it's been around for a while! But it seems us Canadians were late to the party, only getting pet insurance in 1989. 😺🍁So, why don't more Canadians have pet insurance? 😼<br><br>
Surprisingly, less than 3% of us have taken the leap to secure our fur babies' future. Maybe it's the lack of meow-ledge or the late start, but the U.K. and Sweden are light years ahead of us in this game. <br><br>🇬🇧🇸🇪The Wallet Crunch 🐾💵
Fellow kittizens, the cost of owning a pet ain't just kibble and cuddles. Unexpected vet bills can claw their way into your finances. For just a day at the pet hospital, you might be coughing up around $1,200. That's a lot of catnip! 🌿💸<br>

<br>What is the Deal with Pet Insurance? 🐱‍🐉<br>
<br>Pet insurance won’t buy you fancy litter, but it's like a life saver when Fluffy falls sick. It's all about managing risk—how much can you truly afford when health hiccups happen?  An alternative to paying the monthly bill would be to take that and
put those funds into a special high-yield savings account which can be accessed at anytime a calamity strikes.  <br>

<br>Choices, Choices 🐾📝<br>
<br>From large financial institutions to smaller, dedicated insurers, Canada has a purr-etty good selection of pet insurance providers. And they offer everything from basic to premium plans. So, weigh your options like you would a bag of treats! 🍖🤔<br>

<br>The Growing Trend 📈<br>
Although we're a bit behind, the pet insurance market in Canada has grown over 22% last year! The word is getting out, but it's essential to know your options and what you're getting into. 📊🐱</p>   🐾📊<br>
  <p>Cost and Coverage 🤑🛡️
Canadians pay an average of around $68.96/month for dogs and $35.58/month for cats. And what's covered varies widely—from accidents to illnesses and even some dental work. 🐶🐱But What If I Skip Insurance? 🐾🤷‍♀️<br>
Here comes the StingyCat tip: If you decide to skip on pet insurance, make sure you've got a robust emergency fund for your furry friend. You never know when a little 'oops' moment turns into a 'yikes, that's expensive!' 🚨💰
<br>Why Bother with Pet Insurance? 🐾🏥<br>
Your furball isn’t just a pet; they’re family. And because accidents or illnesses don't knock before entering, having a plan helps you face whatever hurdles come your way—financially and emotionally. 🐱‍🚀💕<br>

So, dear fur-iends, whether it's pet insurance or a well-stocked emergency fund, choose the path that keeps your kitty's tail high and wallet full. 🐾👛<br>

🐾 StingyCat Tip: Upload your pet insurance policy, and we'll analyze it, making it as easy to understand as a game of fetch. Plus, we'll remind you when it's time for renewal in your financial calendar and when it's time to get your annual check-up for your furry friend. Staying on top of their health is one great way to prevent future bills. 📅💡<br>

Meow-tastic, isn't it? 🐾🎉<br><br>

If you'd like RiskyPaws to work to gather a group rate together with our users please send some feedback to us.  <br><br> 

<button class="stingycat-button" @click="sendFeedback">Send Feedback</button>






</p>
     
    </div>
</div><br><br><br><br><br><br></div>
  </template>

<script>
export default {
  methods: {
    sendFeedback() {
      const subject = encodeURIComponent("StingyCat Group Plan Feedback");
      const body = encodeURIComponent("I am interested in a group plan for RiskyPaws. Here's my feedback...");
      window.location.href = `mailto:feedback@stingycat.com?subject=${subject}&body=${body}`;
    },
  },
};
</script>

<style scoped>
.container {
  background-color: #4A148C;
  color: black;
  padding: 20px;
  border-radius: 20px;
}
.stingycat-button {
  background-color: #4A148C; /* Black */
  border: none;
  border-radius: 50px;  /* Fully rounded corners */
  color: white;  /* Text color */
  font-size: 1.2em;
  padding: 12px 24px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
}

.stingycat-button:hover {
  background-color: black;  /* Orange */
}

.content {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  color: black;
}
</style>